import axios from 'axios';
import config from '@/config';
import * as constants from '../constants';

const { endpoints } = config.catalog;

const fetchProduct = ({ commit, dispatch }, id = '') => (
  new Promise((resolve, reject) => {
    axios({ url: endpoints.product(id) })
      .then((resp) => {
        commit(constants.CATALOG_PRODUCT_FETCH, resp.data);
        resolve(resp.data);
      })
      .catch((err) => {
        commit(constants.CATALOG_PRODUCT_FETCH, {});
        dispatch('core/showGeneralError', { err }, { root: true });
        reject(err);
      });
  })
);

const fetchCategory = ({ commit, dispatch }, id = '') => (
  new Promise((resolve, reject) => {
    axios({ url: endpoints.category(id) })
      .then((resp) => {
        commit(constants.CATALOG_CATEGORY_FETCH, resp.data);
        resolve(resp.data);
      })
      .catch((err) => {
        commit(constants.CATALOG_CATEGORY_FETCH, {});
        dispatch('core/showGeneralError', { err }, { root: true });
        reject(err);
      });
  })
);

export default {
  fetchProduct,
  fetchCategory,
};
